var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5A1E2A",
    d: "M10.296 9.376h1.488V16h-1.488zm-.112-2.4q0-.352.272-.592.288-.24.624-.24a.84.84 0 0 1 .592.24q.272.24.272.592 0 .368-.272.608a.87.87 0 0 1-.592.224.96.96 0 0 1-.624-.24.76.76 0 0 1-.272-.592"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    stroke: "#5A1E2A"
  })));
};
export default SvgInfo;